import axiosInstance from "../lib/axios";

interface GetDeliveryOrderRequest {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

export interface DeliveryOrderItemRequest {
  description: string;
  qty: number;
  unit: string;
  remark?: string;
  product_id?: number | null;
}

export interface CreateDeliveryOrderRequest {
  po_number: string;

  customer_id_ref?: number | null;

  delivery_date: string;
  due_date: string;
  sales_id: number | null;
  checked_by: string;
  approved_by: string;
  received_by: string;

  delivery_order_status_id: number;

  items: DeliveryOrderItemRequest[];
}

// =========================
// Delivery Order List
// =========================

export const getDeliveryOrder = async ({
  page = 1,
  limit = 10,
  search,
  status,
}: GetDeliveryOrderRequest) => {
  const body = {
    page,
    limit,
    search,
    status,
  };

  const { data } = await axiosInstance.post(
    "/DeliveryOrder/List",
    body
  );

  return data;
};

// =========================
// Create Delivery Order
// =========================

export const createDeliveryOrder = (
  data: CreateDeliveryOrderRequest
) => {
  return axiosInstance.post(
    "/DeliveryOrder/Create",
    data
  );
};

// =========================
// Get Delivery Order By ID
// =========================

export const getDeliveryOrderById = (id: number) => {
  return axiosInstance.get(
    `/DeliveryOrder/${id}`
  );
};

// =========================
// Edit Delivery Order
// =========================

export const editDeliveryOrder = (
  id: number,
  data: CreateDeliveryOrderRequest
) => {
  return axiosInstance.put(
    `/DeliveryOrder/${id}`,
    data
  );
};

// =========================
// Edit Delivery Order Status
// =========================

export interface EditDeliveryOrderStatusRequest {
  delivery_order_status_id: number;
}

export const editDeliveryOrderStatus = (
  id: number,
  data: EditDeliveryOrderStatusRequest
) => {
  return axiosInstance.put(
    `/DeliveryOrder/${id}/status`,
    data
  );
};

// =========================
// Delete Delivery Order
// =========================

export const deleteDeliveryOrderById = (id: number) => {
  return axiosInstance.delete(
    `/DeliveryOrder/${id}`
  );
};

// =========================
// Delivery Order PDF
// =========================

export const deliveryOrderPdf = (id: number) => {
  return axiosInstance.post(
    `/DeliveryOrder/${id}/pdf`,
    null,
    {
      responseType: "blob",
    }
  );
};

// =========================
// Delivery Order Status List
// =========================

export const getdeliveryOrderStatus = async () => {
  const { data } = await axiosInstance.get(
    "/DeliveryOrder/deliverOrder-status"
  );

  return data;
};